import { useEffect } from 'react';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ProcessTimeline from './components/ProcessTimeline';
import ServiceCTA from './components/ServiceCTA';
import { SchemaOrg, updateMetaTags, updateTitle, updateCanonical } from '../../utils/seo';

export default function ServicesPage() {
  useEffect(() => {
    updateTitle('Our Services - Parking Lot Striping, Sealcoating & Repair | Sooner Blacktop');
    updateCanonical('/services');
    updateMetaTags({
      description: 'Complete pavement maintenance services including parking lot striping, sealcoating, crack sealing, and asphalt repair. Professional service for commercial properties in Oklahoma City.',
      keywords: 'parking lot services, striping services, sealcoating services, asphalt repair, crack sealing, pavement maintenance',
      'og:title': 'Our Services - Parking Lot Striping, Sealcoating & Repair | Sooner Blacktop',
      'og:description': 'Complete pavement maintenance services including parking lot striping, sealcoating, crack sealing, and asphalt repair.',
      'twitter:title': 'Our Services - Parking Lot Striping, Sealcoating & Repair | Sooner Blacktop',
      'twitter:description': 'Complete pavement maintenance services including parking lot striping, sealcoating, crack sealing, and asphalt repair.',
    });
  }, []);

  const serviceSchema = {
    '@type': 'Service',
    serviceType: 'Pavement Maintenance',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Sooner Blacktop',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Oklahoma City',
        addressRegion: 'OK',
        addressCountry: 'US',
      },
    },
    areaServed: {
      '@type': 'State',
      name: 'Oklahoma',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Pavement Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Parking Lot Striping',
            description: 'Professional parking lot line striping and pavement marking services.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Sealcoating',
            description: 'Asphalt sealcoating services to protect and preserve parking lots.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Crack Sealing',
            description: 'Professional crack sealing to prevent water infiltration and damage.',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Asphalt Repair',
            description: 'Complete asphalt repair and patching for damaged pavement.',
          },
        },
      ],
    },
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      <SchemaOrg type="Service" data={serviceSchema} />
      <ServicesHero />
      <ServicesList />
      <ProcessTimeline />
      <ServiceCTA />
    </div>
  );
}
